import { useEffect, useState, useMemo, useRef } from 'react';
import FoldersDisplayItem from './FoldersDisplayItem';
import ReplyIcon from '@mui/icons-material/Reply';
import HomeIcon from '@mui/icons-material/Home';

export default function FoldersDisplay(props) {
    const {currentlyViewing, currentUser, setTarget, updateTarget, deleteItem, 
        target, moveOut, moveIn, type, input, setInput, handleRegenURL, defaultSkin, total} = props;
    const [menuOpen, setMenuOpen] = useState(false);
    const [selector, setSelector] = useState([])
    const menuRef = useRef(null);

    function handleMenuClick(id, type) {
        if (menuOpen.id === id && menuOpen.type === type) {
            setMenuOpen(false)
        } else {
            setMenuOpen({id:id, type:type})
        }
    }
        
    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }
        
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const skinViewing = useMemo(() => {
        let items = total;
    
        for (const folderId of selector) {
            const folder = items.find(item => (item.type === "skinFolder") && item.id === folderId);
            if (!folder) return [];
            items = folder.children || [];
        }
            return items;
    }, [total, selector]);
    
    const breadcrumbs = useMemo(() => {
        const crumbs = [];
        let items = total;
    
        for (const folderId of selector) {
            const folder = items.find(item => (item.type === "skinFolder") && item.id === folderId);
            if (!folder) break;
    
            crumbs.push({
                id: folder.id,
                title: folder.title,
                type: folder.type
            });
    
            items = folder.children || [];
        }
    
        return crumbs;
    }, [total, selector]);

    function handleBackClick() {
        if (selector.length > 0) {
            setSelector(prev => (prev.slice(0,-1)));
        }
    }

    function handleHomeClick() {
        setSelector([]);
    }

    useEffect(() => {
        setMenuOpen(false)
    }, [target])

    return(
        <div>
            {type==="skin-select" && <div className="folder-toolbar">
                <div className="folder-explore-tools" id="skin-select-explore-tools">
                    <div className="folder-button" onClick={handleHomeClick}><HomeIcon /></div>
                    <div className="folder-button" onClick={handleBackClick}><ReplyIcon /></div>
                    <nav className="folder-navigator" id="skin-selector-navigator">
                        {breadcrumbs.map((crumb, index) => (
                            <span key={crumb.id}>
                                {"/"}
                                <button
                                    onClick={() =>
                                        setSelector(prev => (prev.slice(0, index + 1)))
                                    }
                                >
                                    {crumb.title}
                                </button>
                            </span>
                        ))}
                    </nav>
                </div>
            </div>}
            <div id="folders-display-container">
                <div id="folders-display" >
                    {type !== "skin-select" && currentlyViewing.map((item, index) => {
                    return (
                        <FoldersDisplayItem 
                            key={index} item={item} 
                            currentUser={currentUser} 
                            setTarget={setTarget} 
                            updateTarget={updateTarget}
                            target={target}
                            menuOpen={menuOpen} 
                            handleMenuClick={handleMenuClick}
                            deleteItem={deleteItem}
                            moveOut={moveOut}
                            moveIn={moveIn}
                            type={type}
                            input={input}
                            setInput={setInput}
                            handleRegenURL={handleRegenURL}
                            defaultSkin={defaultSkin}
                            setSelector={setSelector}
                        />
                    )
                    })}
                    {type === "skin-select" && skinViewing.map((item, index) => {
                    return (
                        <FoldersDisplayItem 
                            key={index} item={item} 
                            currentUser={currentUser} 
                            setTarget={setTarget} 
                            updateTarget={updateTarget}
                            target={target}
                            menuOpen={menuOpen} 
                            handleMenuClick={handleMenuClick}
                            deleteItem={deleteItem}
                            moveOut={moveOut}
                            moveIn={moveIn}
                            type={type}
                            input={input}
                            setInput={setInput}
                            handleRegenURL={handleRegenURL}
                            defaultSkin={defaultSkin}
                            setSelector={setSelector}
                            menuRef={menuRef}
                        />
                    )
                    })}
                </div>
            </div>
        </div>
    )
}